import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { postDataLogin } from '../../../ApiServices/ApiService';
import { ORG_MFA_LOGIN,ORG_MFA_RESEND } from '../../../ApiServices/BaseURL';
import { useLocation } from 'react-router-dom';
import { useTheme } from '../../../GlobalContext/GlobalContext';

const MFAScreenController = () => {
    const [mfa, setMfa] = useState(''); // State to store the OTP entered by the user
    const [error, setError] = useState(''); // State for error messages
    const [loading, setLoading] = useState(false); // State to track loading
    const [resendTimer, setResendTimer] = useState(30); // Timer for resend functionality
    const { theme, setCompanyId } = useTheme();
    const [mfaLoading, setMfaLoading] = useState(false); // State to track loading
    const [success, setSuccess] = useState(''); // State for success messages
    const [count, setCount] = useState(1);

    const location = useLocation();
    const email = location.state?.email;
    const sessionTkn = location.state?.sessionTkn || '';

    console.log("email", email);


    const navigate = useNavigate();

    // Function to handle input changes for MFA code
    const handleMfaChange = (text) => {
        // Only allow numbers and limit the input to 6 characters
        const value = text.replace(/[^0-9]/g, '').slice(0, 6);
        setMfa(value);
    };

    // Function to verify the MFA code
    const verify = async () => {
        setError('');

        // Validation for the MFA code
        if (mfa.length !== 6) {
            setError('Please enter a valid 6-digit code.');
            return;
        }

        setLoading(true); // Show the loader before making the request

        try {
            const payload = {
                user_id: email,
                user_mfa_code: mfa,
            };

            const response = await postDataLogin(ORG_MFA_LOGIN, payload);

            // Handle response based on status code
            if (response.statusCode === 200) {
                if (response.message === 'success') {
                    var themeId = response?.dataJ[0]?.org_ui_template_id || 6
                    setCompanyId(themeId);
                    localStorage.setItem(`themeId`, themeId);
                    // const role = 'SUPER-ADMIN'
                    // localStorage.setItem(`userRole`, role); //need to change dynamic
                    localStorage.setItem(`userRole`, response?.dataJ[0]?.emp_role);
                    var companyInfo ={
                      company_name: response?.dataJ[0]?.emp_company_name,
                      company_logo: response?.dataJ[0]?.logo_url
                    }
                    localStorage.setItem('companyInfo', JSON.stringify(companyInfo))
                    let userData = JSON.stringify(response?.dataJ[0]);
                    localStorage.setItem('_userInfo_', userData);
                    var whatsAppStatus = response?.dataJ[0]?.watsapp_status || 0
                    localStorage.setItem(`whatsAppStatus`, whatsAppStatus);
                    navigate('/dashboard');
                } else {
                    setError(response?.info || 'Failed to verify the code.');
                }
            } else if (response.statusCode === 500) {
                setError(response?.info || 'Internal Server Error. Please try again later.');
            } else {
                setError('No Internet Connection Detected or Connection Is Slow.');
            }
        } catch (error) {
            // Handle exceptions
            console.error('Error during MFA verification:', error);
            setError('An error occurred. Please check your connection and try again.');
        } finally {
            setLoading(false); // Hide the loader after request is completed
        }
    };


      // Function to handle resend logic
    const resendCode = async () => {
        setError('');
        if (resendTimer > 0) return;

        try {
            setMfaLoading(true);

            const payload = {
                user_id: email,
                attempt_count: count,
            }

            // Add API call to resend the MFA code here
            const response = await postDataLogin(ORG_MFA_RESEND, payload);

            // Handle response based on status code
            if (response.statusCode === 200) {
                if (response.message === 'success') {
                    setSuccess(response?.info);
                    setTimeout(() => {
                        setSuccess('');
                    }, 3000);
                } else {
                    setError(response?.info || 'Failed to send the code.');
                }
            } else if (response.statusCode === 500) {
                setError(response?.info || 'Internal Server Error. Please try again later.');
            } else {
                setError('No Internet Connection Detected or Connection Is Slow.');
            }
        } catch (error) {
            // Handle exceptions
            console.error('Error during send MFA:', error);
            setError('An error occurred. Please check your connection and try again.');
        } finally {
            setCount(prev => prev + 1);
            setResendTimer(30);
            setMfaLoading(false); // Hide the loader after request is completed
        }
    };
    // Countdown for resend timer
    useState(() => {
        const timer = setInterval(() => {
            setResendTimer((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return {
        mfa,
        setMfa,
        handleMfaChange,
        verify,
        resendCode,
        loading,
        error,
        resendTimer,
        success,
        mfaLoading
    };
};

export default MFAScreenController;
